import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boldColor',
})
export class BoldColorPipe implements PipeTransform {
  transform(texto: string): string {
    const regexBold = new RegExp(/([*])(?:(?=(\\?))\2.)*?\1/g, 'gi');
    texto = texto.replace(
      regexBold,
      (match) =>
        `<span class="lovers-font--bold">${match.replace(/\*/g, '')}</span>`
    );

    const regexColor = new RegExp(/([´])(?:(?=(\\?))\2.)*?\1/g, 'gi');
    texto = texto.replace(
      regexColor,
      (match) =>
        `<span class="lovers-font--color">${match.replace(/\´/g, '')}</span>`
    );

    return texto;
  }
}
